import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  constructor() {}

  public openModal() {
    const modal = document.getElementById('modal');
    const fade = document.getElementById('fade');
    if (modal && fade) {
      modal.style.display = 'block';
      modal.style.left = (window.innerWidth - 200) / 2 + 'px';
      fade.style.display = 'block';
    }
  }

  public closeModal() {
    const modal = document.getElementById('modal');
    const fade = document.getElementById('fade');
    if (modal && fade) {
      modal.style.display = 'none';
      fade.style.display = 'none';
    }
  }
}
